import { createSelector } from 'reselect'

import * as sharedDataset from './shared-dataset'

const sharedDatasetSelector = state => state.sharedDataset

export const datasetSelector = createSelector(sharedDatasetSelector, sharedDataset.datasetSelector)


// export const datasetHomeURLSelector = createSelector(
//   state => state.router
//   dataset => (`${dataset.public_guid}`)
// )



// WEBPACK FOOTER //
// ./src/selectors/index.js